import { memo } from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

import { useMobile } from '../../../../hooks/useMobile';
import useWindowSize from '../../../../common/hooks/useWindowSize';

import { DesktopHead, MobileHead } from './items';
import {
  HEIGHT_OF_DESKTOP_HEAD_CONTAINER,
  HEIGHT_OF_MOBILE_HEAD_CONTAINER,
  HEIGHT_OF_MOBILE_SUBPAGES
} from '../consts';

interface StyleProps {
  includeSubpages: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  head: {
    width: '100%',
    height: HEIGHT_OF_DESKTOP_HEAD_CONTAINER,
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      height: ({ includeSubpages }: StyleProps) =>
        `calc(${HEIGHT_OF_MOBILE_HEAD_CONTAINER} + ${includeSubpages ? HEIGHT_OF_MOBILE_SUBPAGES : '0px'})`,
      top: 0,
      padding: 0,
      position: 'fixed',
      zIndex: 100
    }
  }
}));

interface Props {
  includeSubpages: boolean;
}

const Head = ({ includeSubpages }: Props) => {
  const classes = useStyles({ includeSubpages });
  const { width } = useWindowSize();
  const { isMobile } = useMobile();

  if (!width || isMobile === 'initialized') {
    return null;
  }

  return <Box className={classes.head}>{isMobile === true ? <MobileHead /> : <DesktopHead />}</Box>;
};

export default memo(Head);
